export function generateSurveySessionId() {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 11);
  return `${timestamp}-${random}`;
}

export function getCreatorSurveyCompleted(creatorId: string, creatorSurveyId: string) {
  const userCompleted = localStorage.getItem('creator_survey_completed');
  if (userCompleted === `${creatorId}`) {
    return true;
  }
  return false;
}

export function setCreatorSurveyCompleted(creatorId?: string, creatorSurveyId?: string) {
  localStorage.setItem('creator_survey_completed', `${creatorId}`);
}

/**
 * Interpolates creator name into survey question text
 * Replaces %CREATOR_NAME% placeholder with the actual creator name
 * @param questionText - The survey question text that may contain %CREATOR_NAME% placeholder
 * @param creatorName - The creator's name to interpolate
 * @returns The question text with creator name interpolated
 */
export function interpolateCreatorName(questionText: string, creatorName?: string): string {
  if (!creatorName) {
    return questionText;
  }

  return questionText.replace(/%CREATOR_NAME%/g, creatorName);
}
